'use client'
import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import { PrismicNextLink } from '@prismicio/next'
import { VideoPlayer } from '@/components'
import Download from '@/assets/images/icons/icon-download.svg'
/**
 * Props for `VideoWithIntro`.
 */
export type VideoWithIntroProps =
  SliceComponentProps<Content.VideoWithIntroSlice>;

/**
 * Component for "VideoWithIntro" Slices.
 */
const VideoWithIntro: FC<VideoWithIntroProps> = ({ slice }) => {

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`${slice.primary.style.toLowerCase()} px-4 md:px-8 lg:px-12 font-fellix text-jade`}
    >
      <div className="max-w-[880px] mx-auto py-24">
        <div className="inner-wrapper">
          {slice.primary.block_title ?
          <article className="text-[32px] leading-[38px] md:text-[48px] md:leading-[60px] font-semibold text-center mb-[63px]">
            <PrismicRichText field={slice.primary.block_title}/>
          </article>
          : <></>}
          {slice.primary.intro_text  ? 
          <article className="text-[20px] md:text-[28px] leading-[28px] md:leading-[36px] mx-auto max-w-[650px] text-center mb-24">
            <PrismicRichText field={slice.primary.intro_text}/>
          </article>
          : <></> }
            <VideoPlayer dataSet={slice.primary}/>
            <div className="grid grid-cols-12 w-full gap-0 mt-6">
              <div className="col-span-8">
                <p className="font-semibold text-[20px] leading-[24px] mb-3">{slice.primary.video_title}</p>
                <p className="text-[18px]">{slice.primary.video_runtime}</p>
              </div>
              <div className="col-span-4 flex justify-end">
                {slice.primary.instructions && slice.primary.instructions.link_type !== "Any" ?
                  <PrismicNextLink field={slice.primary.instructions} className="inline-block">
                    Download PDF <Download className="inline-block ml-3 relative -top-[4px]"/>
                  </PrismicNextLink>
                : <></> }
              </div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default VideoWithIntro;
